import { render, staticRenderFns } from "./ProjectProposedBreakPage.vue?vue&type=template&id=b85c77a6&scoped=true&"
import script from "./ProjectProposedBreakPage.vue?vue&type=script&lang=js&"
export * from "./ProjectProposedBreakPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectProposedBreakPage.vue?vue&type=style&index=0&id=b85c77a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85c77a6",
  null
  
)

export default component.exports